"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANUAL_MAX_PDF_BYTES = exports.manualTypeOf = exports.manualSource = exports.MANUAL_REPORT_TYPES = exports.MANUAL_AI_FLASH = exports.MANUAL_PRODUCER = void 0;
// 手動配信 (2026-09-29): a one-off report that did not come from SR Writer,
// e.g. an Initiation sent with its full PDF. It gets its own identity
// (producer 'manual', a fresh externalId), so it never touches a Writer
// report's revision or product id.
exports.MANUAL_PRODUCER = 'manual';
// The AI 説明会速報 sent by hand (user, 2026-10-16) goes out as the 速報レポート
// app's own product: producer sr-earnings, so vendors get its [EA] title prefix
// and it is counted, held (PAUSED_PRODUCERS) and recalled with sr-earnings.
exports.MANUAL_AI_FLASH = 'AI_FLASH';
// SR Writer's ProjectType values: vendor report-type rules (Bloomberg = FLASH only) key on these.
exports.MANUAL_REPORT_TYPES = ['FULL', 'ESPRESSO', 'FLASH', 'NEWS_UPDATE', 'POST_INTERVIEW_UPDATE', exports.MANUAL_AI_FLASH];
const manualSource = (type) => type === exports.MANUAL_AI_FLASH ? { producer: 'sr-earnings', reportType: 'FLASH' } : { producer: exports.MANUAL_PRODUCER, reportType: type };
exports.manualSource = manualSource;
// The form option a received request maps back to (「この内容で入力」).
const manualTypeOf = (producer, reportType) => producer === 'sr-earnings' && reportType === 'FLASH'
    ? exports.MANUAL_AI_FLASH
    : exports.MANUAL_REPORT_TYPES.includes(reportType) && reportType !== exports.MANUAL_AI_FLASH
        ? reportType
        : undefined;
exports.manualTypeOf = manualTypeOf;
// Cloud Run caps a request at 32 MiB and the PDF travels base64-encoded (+33%).
exports.MANUAL_MAX_PDF_BYTES = 20 * 1024 * 1024;
